/* global axios */
import ApiClient from './ApiClient';

class FunnelsAPI extends ApiClient {
  constructor() {
    super('funnels', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // Stages
  getStages(funnelId) {
    return axios.get(`${this.url}/${funnelId}/stages`);
  }

  createStage(funnelId, data) {
    return axios.post(`${this.url}/${funnelId}/stages`, data);
  }

  updateStage(funnelId, stageId, data) {
    return axios.patch(`${this.url}/${funnelId}/stages/${stageId}`, data);
  }

  deleteStage(funnelId, stageId) {
    return axios.delete(`${this.url}/${funnelId}/stages/${stageId}`);
  }

  reorderStages(funnelId, stageIds) {
    return axios.post(`${this.url}/${funnelId}/stages/reorder_batch`, {
      stage_ids: stageIds,
    });
  }

  // Items
  getItems(funnelId, params = {}) {
    return axios.get(`${this.url}/${funnelId}/items`, { params });
  }

  createItem(funnelId, data) {
    return axios.post(`${this.url}/${funnelId}/items`, data);
  }

  updateItem(funnelId, itemId, data) {
    return axios.patch(`${this.url}/${funnelId}/items/${itemId}`, data);
  }

  deleteItem(funnelId, itemId) {
    return axios.delete(`${this.url}/${funnelId}/items/${itemId}`);
  }

  moveItem(funnelId, itemId, stageId, position) {
    return axios.post(`${this.url}/${funnelId}/items/${itemId}/move`, {
      funnel_stage_id: stageId,
      position,
    });
  }

  // AI Insights
  getAiInsights(funnelId) {
    return axios.post(`${this.url}/${funnelId}/ai_insights`);
  }

  // Contact Items - get all funnel items for a contact
  getContactItems(contactId) {
    return axios.get(`${this.url}/contact_items`, {
      params: { contact_id: contactId },
    });
  }

  // Members
  getMembers(funnelId) {
    return axios.get(`${this.url}/${funnelId}/members`);
  }

  addMember(funnelId, userId, role = 'member') {
    return axios.post(`${this.url}/${funnelId}/members`, {
      user_id: userId,
      role,
    });
  }

  updateMember(funnelId, memberId, role) {
    return axios.patch(`${this.url}/${funnelId}/members/${memberId}`, { role });
  }

  removeMember(funnelId, memberId) {
    return axios.delete(`${this.url}/${funnelId}/members/${memberId}`);
  }

  // Automations
  getAutomations(funnelId) {
    return axios.get(`${this.url}/${funnelId}/automations`);
  }

  createAutomation(funnelId, data) {
    return axios.post(`${this.url}/${funnelId}/automations`, data);
  }

  updateAutomation(funnelId, automationId, data) {
    return axios.patch(
      `${this.url}/${funnelId}/automations/${automationId}`,
      data
    );
  }

  deleteAutomation(funnelId, automationId) {
    return axios.delete(
      `${this.url}/${funnelId}/automations/${automationId}`
    );
  }

  // Stage API Integration
  getStageApiIntegration(funnelId, stageId) {
    return axios.get(
      `${this.url}/${funnelId}/stages/${stageId}/api_integration`
    );
  }

  saveStageApiIntegration(funnelId, stageId, data) {
    return axios.post(
      `${this.url}/${funnelId}/stages/${stageId}/api_integration`,
      data
    );
  }

  updateStageApiIntegration(funnelId, stageId, data) {
    return axios.patch(
      `${this.url}/${funnelId}/stages/${stageId}/api_integration`,
      data
    );
  }

  deleteStageApiIntegration(funnelId, stageId) {
    return axios.delete(
      `${this.url}/${funnelId}/stages/${stageId}/api_integration`
    );
  }

  syncStageApiIntegration(funnelId, stageId) {
    return axios.post(
      `${this.url}/${funnelId}/stages/${stageId}/api_integration/sync`
    );
  }
}

export default new FunnelsAPI();
